export default __webpack_public_path__ + "static/js-eb703172120babf6015abd26b9c0c60b.png";